import { useState } from "react";
import TitleBar from "./TitleBar";
import TerminalBody from "./TerminalBody";
import useDraggable from "../hooks/useDraggable";
import useTerminalEngine from "../hooks/useTerminalEngine";
import { PROFILE } from "../data/portfolio";
import { useNavigate } from "react-router-dom";

/**
 * <TerminalWindow fullScreen />        → fills the viewport, not draggable
 * <TerminalWindow fullScreen={false} />→ floating window, drag by the title bar,
 *                                        no page background of its own
 *
 * The green traffic light lets the user toggle fullscreen at runtime
 * regardless of the initial prop.
 */
export default function TerminalWindow({ fullScreen = false ,path = false}) {
  const [isFullScreen, setIsFullScreen] = useState(fullScreen);
  const [isMinimized, setIsMinimized] = useState(false);
  const navigate = useNavigate();

  const { position, onPointerDown } = useDraggable({ x: 48, y: 48 }, !isFullScreen);

  const engine = useTerminalEngine();

  const handleClose = ()=>{
    if(path){
      navigate("/");
    }
  }

  const windowStyle = isFullScreen
    ? { position: "fixed", inset: 0 }
    : { position: "fixed", left: 0, top: 0, transform: `translate(${position.x}px, ${position.y}px)` };

  return (
    <div
      className={`z-50 ${isFullScreen ? "flex items-center justify-center bg-neutral-950" : ""}`}
      style={windowStyle}
    >
      <div
        className={`overflow-hidden border border-white/10 shadow-2xl shadow-black/60 bg-[#161616] ${
          isFullScreen ? "w-screen h-screen rounded-none" : "w-[92vw] max-w-2xl sm:w-[640px] rounded-lg"
        }`}
      >
        <TitleBar
          title={`${PROFILE.user} — zsh — 80×24`}
          draggable={!isFullScreen}
          onPointerDown={onPointerDown}
          onClose={handleClose}
          onMinimize={() => setIsMinimized((m) => !m)}
          onToggleFullScreen={() => setIsFullScreen((f) => !f)}
        />
        {!isMinimized && (
          <TerminalBody
            lines={engine.lines}
            cwd={engine.cwd}
            user={PROFILE.user}
            host={PROFILE.host}
            booted={engine.booted}
            input={engine.input}
            setInput={engine.setInput}
            handleKeyDown={engine.handleKeyDown}
            scrollRef={engine.scrollRef}
            inputRef={engine.inputRef}
            heightClass={isFullScreen ? "h-[calc(100vh-2.25rem)]" : "h-[70vh] sm:h-[560px]"}
          />
        )}
      </div>
    </div>
  );
}